<a class="amber p-0" data-original-title="" title="" (click)="onOpenSwapModal()">
  <i class="ft-repeat font-small-3 mr-2"></i>
</a>